import { Divider, Grid } from '@mui/material'
import { useContext, useEffect } from 'react'

import styles from "../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss";
import globalStyles from "../../assets/styles/global.module.scss";
import headerStyles from '../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'

import BillingUsage from '../../components/billing/billingUsage';
import GlobalPageHeaderText from '../../components/utility/globalPageHeaderText';

import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { billingPlansBreadcrumb, billingUsageBreadcrumb, dashboardBreadcrumb } from '../../utils/breadcrumb';
import useGenericHook from '../../hooks/useGenericHook';
import ChangePlan from '../../components/billing/changePlan';

const BillingUsageGlobal = () => {

    const { isScreenBelow600: smallScreen } = useGenericHook();
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const innerHeight = window.innerHeight - 110;

    const currentPath = window.location.pathname.toLowerCase();
    const isPlansPage = currentPath.includes("/plans");

    useEffect(() => {
        const updatedBreadcrumbs = [
            { ...dashboardBreadcrumb },
            ...(isPlansPage
                ? [{ ...billingUsageBreadcrumb }, { ...billingPlansBreadcrumb, isActive: true }]
                : [{ ...billingUsageBreadcrumb, isActive: true }])
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [isPlansPage])

    return (
        <>
            <Grid item xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={isPlansPage ? "Change your plan" : "Billing & Usage"}
                                    flagMainTextOnly
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.pageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} 
                        className={styles.pageOutlet}
                        sx={{ maxHeight: `${innerHeight}px`, overflow: "auto", paddingTop: "15px !important" }}
                    >
                        {isPlansPage ? <ChangePlan /> : <BillingUsage />}
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default BillingUsageGlobal;